import type { IArticleRepository, GetArticlesParams } from '@/domain/repositories/article.repository'
import type { Article } from '@/domain/entities/article.entity'
import { articlesContract } from '@bibleawr/landing2-contract'
import { createLandingTsRestClient } from '../api/ts-rest-client'
import { ApiError } from '../errors'
import { mapArticleDtoToEntity, mapArticleDtoArrayToEntities } from '../mappers/article.mapper'
import { toNumberOrNull } from '@/utils/value.helpers'

export class ArticleRepository implements IArticleRepository {
  private readonly client = createLandingTsRestClient(articlesContract)

  async findMany (params?: GetArticlesParams): Promise<Article[]> {
    const res = await this.client.getArticles({
      query: { article_locale: params?.article_locale, limit: params?.limit },
    })
    if (res.status !== 200) throw new ApiError('Failed to fetch articles', res.status)
    return mapArticleDtoArrayToEntities(Array.isArray(res.body?.data) ? res.body.data : [])
  }

  async findBySlug (slug: string): Promise<Article | null> {
    const res = await this.client.getArticleBySlug({ params: { slug } })
    if (res.status === 404) return null
    if (res.status !== 200) throw new ApiError('Failed to fetch article by slug', res.status)
    const raw = res.body?.data
    if (!raw?._id) return null
    return mapArticleDtoToEntity(raw)
  }

  async incrementView (articleId: string): Promise<number | null> {
    const res = await this.client.incrementArticleView({ params: { article_id: articleId }, body: {} })
    if (res.status === 404) return null
    if (res.status !== 200) throw new ApiError('Failed to increment article view', res.status)
    return toNumberOrNull(res.body?.data?.article_views)
  }
}
